export default "__VITE_ASSET__CTT2Pxy9__"